import React, { useState, useEffect, useRef, useMemo } from 'react'

const ScrollObserver = ({ className, children, ...props }) => {
  // start observing

  const [isVisible, setisVisible] = useState(false)
  const ref = useRef()
  const intersectionObserverCallback = entries => {
    const [entry] = entries
    setisVisible(entry.isIntersecting)
  }

  const observer = new IntersectionObserver(intersectionObserverCallback)
  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current)
    }
    // Remove event listeners on cleanup
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
    }
  }, [observer, ref.current])
  const open = useMemo(() => isVisible, [isVisible])
  return (
    <div
      ref={ref}
      className={`${open ? 'show' : 'hide'} observer_scroller ${
        className || ''
      }`}
      {...props}
    >
      {children}
    </div>
  )
}

export default ScrollObserver
